"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ICONS = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ICONS = exports.ICONS = {
  anchor: "anchor",
  chevronDown: "chevron-down",
  chevronUp: "chevron-up",
  close: "close",
  code: "code",
  collapse: "collapse",
  copy: "copy",
  delete: "delete",
  drag: "drag",
  error: "error",
  expand: "expand",
  externalLink: "external-link",
  help: "help",
  information: "information",
  menu: "menu",
  minus: "minus",
  plus: "plus",
  search: "search",
  share: "share",
  spinner: "spinner",
  success: "success",
  user: "user",
  warning: "warning",
  facebook: "facebook",
  twitter: "twitter",
  instagram: "instagram",
  linkedin: "linkedin",
  youtube: "youtube",
  github: "github",
  rss: "rss",
  email: "email"
};
/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Icon](https://docs.vanillaframework.io/patterns/icons/).
 *
 * Icons provide visual context and enhance usability.
 *
 * @param name One of built-in Vanilla icons or a name of a custom icon that follows `p-icon--{name}` convention.
 * @returns Icon
 */
const Icon = _ref => {
  let {
    className,
    light,
    name,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("i", _extends({
    className: (0, _classnames.default)(className, "p-icon--".concat(name), {
      "is-light": light
    })
  }, props));
};
var _default = exports.default = Icon;